import { useEffect } from "react";
import { useLocation, Link, Navigate } from "react-router-dom";
import { CheckCircle2, Phone, Truck } from "lucide-react";
import { fmtPrice, PHONE } from "@/lib/api";
import { fbTrack } from "@/lib/pixel";

export default function OrderSuccess() {
  const { state } = useLocation();
  const order = state?.order;

  useEffect(() => {
    if (order) {
      fbTrack("Purchase", {
        value: order.total,
        currency: "RON",
        contents: order.items.map((i) => ({ id: i.product_id, quantity: i.quantity })),
        num_items: order.items.reduce((s, i) => s + i.quantity, 0),
      });
    }
  }, [order]);

  if (!order) return <Navigate to="/" replace />;

  return (
    <div className="bg-slate-50 min-h-[70vh]" data-testid="order-success-page">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-2xl border-2 border-slate-100 p-8 text-center">
          <span className="mx-auto bg-eco/10 rounded-full h-20 w-20 flex items-center justify-center mb-5">
            <CheckCircle2 className="h-11 w-11 text-eco" />
          </span>
          <h1 className="font-display font-black text-navy text-3xl tracking-tighter">COMANDĂ PLASATĂ!</h1>
          <p className="text-muted-foreground mt-2">
            Mulțumim, <b className="text-navy">{order.customer.name}</b>! Comanda ta a fost înregistrată.
          </p>
          <p className="text-sm text-muted-foreground mt-1">
            Cod comandă: <span className="font-mono font-bold text-navy">#{order.id.slice(0, 8).toUpperCase()}</span>
          </p>

          <div className="bg-slate-50 rounded-xl p-5 mt-6 text-left space-y-2.5">
            {order.items.map((i) => (
              <div key={i.product_id} className="flex justify-between text-sm">
                <span className="text-slate-700">{i.name} × {i.quantity}</span>
                <span className="font-bold text-navy">{fmtPrice(i.price * i.quantity)} lei</span>
              </div>
            ))}
            <div className="border-t pt-2.5 flex justify-between text-sm">
              <span className="text-muted-foreground">Transport</span>
              <span className="font-bold">{order.shipping === 0 ? "Gratuit" : `${fmtPrice(order.shipping)} lei`}</span>
            </div>
            <div className="flex justify-between font-display font-black text-navy text-lg">
              <span>Total de plată</span><span>{fmtPrice(order.total)} lei</span>
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 text-sm text-navy bg-gold/20 rounded-xl px-4 py-3 mt-5">
            <Truck className="h-5 w-5" /> Plata la livrare · Livrare în 1-2 zile lucrătoare
          </div>

          <div className="flex flex-col sm:flex-row gap-3 mt-7">
            <Link to="/produse" className="flex-1 bg-navy hover:bg-navy-700 text-white font-display font-bold py-3 rounded-xl transition-colors">
              Continuă cumpărăturile
            </Link>
            <a href={`tel:${PHONE}`} className="flex-1 bg-eco hover:bg-green-700 text-white font-display font-bold py-3 rounded-xl flex items-center justify-center gap-2 transition-colors">
              <Phone className="h-4 w-4" /> {PHONE}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
